export enum DestinationDisplayNameTypeEnum {
  HOTEL = "hotel",
  DESTINATION = "destination",
  SLUG = "slug",
  LATLNG = "areaLatLng",
}

export interface RequestDestinationDisplayNameInterface {
  type: DestinationDisplayNameTypeEnum;
  type_id?: string;
  countrySlug?: string;
  citySlug?: string;
  areaSlug?: string;
  hotelSlug?: string;
  latitude?: number;
  longitude?: number;
}

export class ResponseDestinationDisplayNameInterface {
  status: boolean = false;

  displayName: string = "";

  type: DestinationDisplayNameTypeEnum = DestinationDisplayNameTypeEnum.HOTEL;

  typeId?: string;

  countrySlug?: string;

  citySlug?: string;

  areaSlug?: string;

  hotelSlug?: string;

  destinationId?: number;

  hotelId?: string;

  constructor(data: any) {
    this.status = data.status;
    this.displayName = data.displayName;
    this.type = data.type;
    this.typeId = data.type_id;
    this.countrySlug = data.countrySlug;
    this.citySlug = data.citySlug;
    this.areaSlug = data.areaSlug;
    this.hotelSlug = data.hotelSlug;
    this.destinationId = data.destinationId;
    this.hotelId = data.hotelId;
  }
}
